const LeaderCard = require("../../entities/Cards/LeaderCard");
const Leaders = require("../../Constants/Leaders/Leaders");
const { Definition } = require("../../Constants/CardVersions");

// (in the version given: the base game's, or the expansion's for a card it changed)
const LeaderConverter = (leaderName, version) =>
{
    const leader = Definition(Leaders, leaderName, version);
    return leader === undefined ? null : new LeaderCard(leaderName, leader);
}

module.exports = LeaderConverter;